import axios from 'axios';
import store from '@/store';

export default function setupInterceptors() {
    axios.interceptors.request.use(function(config) {
        const token = store.state.user.token;
        if(token) {
            config.headers.Authorization = `bearer ${token}`;
        }
        return config;
    }, function(err) {
        return Promise.reject(err);
    });
}